import React, { useEffect, useState } from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Button, Box, Text, Spinner } from '@chakra-ui/react';



export default function TermsModal({ isOpen, onClose }) {
  const [terms, setTerms] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setLoading(true);
      fetch('/terms.txt')
        .then(res => res.text())
        .then(text => {
          setTerms(text);
          setLoading(false);
        })
        .catch(e => {
          setError('利用規約の取得に失敗しました');
          setLoading(false);
        });
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>利用規約</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {loading ? (
            <Spinner />
          ) : error ? (
            <Text color="red.500">{error}</Text>
          ) : (
            <Box as="pre" fontSize="xs" whiteSpace="pre-wrap" maxH="60vh" overflowY="auto">
              {terms}
            </Box>
          )}
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>閉じる</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
} 